import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectIsLoadingUser = (store: StoreSchema) => store.user.isLoading